import React from 'react';
import styles from './Waveform.module.css';

export const Waveform: React.FC = () => {
  return (
    <div 
      className={styles.waveform}
      role="img"
      aria-label="Audio waveform visualization"
    >
      <div className={styles.bar} aria-hidden="true"></div>
      <div className={styles.bar} aria-hidden="true"></div>
      <div className={styles.bar} aria-hidden="true"></div>
      <div className={styles.bar} aria-hidden="true"></div>
      <div className={styles.bar} aria-hidden="true"></div>
      <div className={styles.bar} aria-hidden="true"></div>
      <div className={styles.bar} aria-hidden="true"></div>
      <div className={styles.bar} aria-hidden="true"></div>
    </div>
  );
};
